import { Button } from '@/shared/ui/button'
import { useSetVisibility } from '../model/use-set-visibility'

interface VisibilityControlProps {
  meetingId: string
  isPrivate: boolean
}

// Переключатель видимости на детали встречи. Текст объясняет, кто увидит
// встречу после переключения, — «приватная» само по себе ничего не говорит.
export function VisibilityControl({ meetingId, isPrivate }: VisibilityControlProps) {
  const setVisibility = useSetVisibility(meetingId)
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-control bg-bg-surface px-4 py-3">
      <p className="text-sm text-text-secondary">
        {isPrivate
          ? 'Встречу видят только организатор, участники и приглашённые.'
          : 'Встречу видит любой сотрудник — как все встречи по умолчанию.'}
      </p>
      <Button
        variant="secondary"
        size="sm"
        disabled={setVisibility.isPending}
        onClick={() => setVisibility.mutate(!isPrivate)}
      >
        {isPrivate ? 'Открыть всем' : 'Скрыть от посторонних'}
      </Button>
    </div>
  )
}
